import React from 'react';
import ModalFormUI from './../../../widgets/form/ModalFormUI';
import InputTextSF from './../../../widgets/form/InputTextSF';
import InputNameSF from './../../../widgets/form/InputNameSF';
import InputPhoneNumberUI from './../../../widgets/form/InputPhoneNumberUI';

const CustomerCreateModalUI = ({
    context, messageList, successMsg, errorList,
    // modes
    createMode, submitted,
    // event handlers
    onSubmit, onCancelClick, setErrorList,
    // customerName attributes and methods
    customerName, onCustomerNameChange, customerNameError, setCustomerNameError,
    // contact attributes and methods
    firstName, lastName, firstNameError, lastNameError, setFirstNameError, setLastNameError, onFirstNameChange, onLastNameChange,
    // phoneNumber attributes and methods
    phoneNumber, onPhoneNumberChange, phoneNumberError, setPhoneNumberError,
    // email attributes and methods
    email, onEmailChange, emailError, setEmailError
}) =>
    <ModalFormUI
        context={context}
        messageList={messageList}
        titleMessageKey='c_create_customer'
        buttonMessageKey='c_add'
        cancelMessageKey='c_cancel'
        isOpen={createMode}
        onRequestClose={onCancelClick}
        successMsg={successMsg}
        setErrorList={setErrorList}
        errorList={errorList}
        onSubmit={onSubmit}
        busy={submitted}
    >
        <InputTextSF type='text' name='customerName' required={true}
            messageList={messageList} labelKey='c_customer_name'
            value={customerName} onChange={onCustomerNameChange}
            error={customerNameError}
            setError={setCustomerNameError}
            autoFocus={true}
        />
        <InputNameSF type='name' name='name' firstName={firstName} lastName={lastName} required={true}
            messageList={messageList} labelKey='c_name'
            firstNameError={firstNameError} lastNameError={lastNameError}
            setFirstNameError={setFirstNameError} setLastNameError={setLastNameError}
            onFirstNameChange={onFirstNameChange} onLastNameChange={onLastNameChange} />

        <InputPhoneNumberUI name='phoneNumber' required={true}
            messageList={messageList} labelKey='c_phone_number'
            value={phoneNumber} onChange={onPhoneNumberChange}
            error={phoneNumberError}
            setError={setPhoneNumberError}
        />

        <InputTextSF type='text' name='email' required={true} maxLength={64}
            messageList={messageList} labelKey='c_email'
            value={email} onChange={onEmailChange}
            error={emailError}
            setError={setEmailError}
        />
    </ModalFormUI>

export default CustomerCreateModalUI;
